import React, { useState } from 'react';

function Help() {
  const [openSection, setOpenSection] = useState(null);

  const faqs = [
    {
      question: "How do I use the website?",
      answer: "You can easily use the website by writing a description of the image you want in the text box, then selecting the appropriate size and style, and clicking the 'Generate' button."
    },
    {
      question: "What's the best way to write a good description?",
      answer: "To get the best results, write a detailed description of the image you want. For example: 'A white cat sitting on a red chair in a sunlit room' instead of just 'cat'."
    },
    {
      question: "Can I download the generated images?",
      answer: "Yes, you can download any generated image by clicking the download button below each image."
    },
    {
      question: "What image sizes are available?",
      answer: "We offer several image sizes: 512×512, 768×768, and 1024×1024 pixels. You can choose the size that best suits your needs."
    },
    {
      question: "Can I share the generated images?",
      answer: "Yes, you can share the generated images with others through the image link or by downloading and sharing them on social media platforms."
    },
    {
      question: "What artistic styles are available?",
      answer: "We offer a variety of artistic styles such as realistic, artistic, cartoon, and anime. You can choose the style that best matches your vision."
    }
  ];

  const tips = [
    "Use detailed descriptions for better results",
    "Try different styles for the same description",
    "Use precise words to describe colors and shapes",
    "You can modify the description and try again for different results",
    "Save images you like in the gallery for later reference"
  ];

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-8 text-center">Help</h1>

      {/* Quick Start Guide */}
      <section className="bg-gray-800 p-6 rounded-lg mb-8">
        <h2 className="text-2xl font-semibold mb-4">Quick Start Guide</h2>
        <div className="space-y-4">
          <div className="flex items-start">
            <div className="bg-blue-600 w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
              <span className="text-white font-bold">1</span>
            </div>
            <p className="text-gray-300">Write a detailed description of the image you want in the text box</p>
          </div>
          <div className="flex items-start">
            <div className="bg-blue-600 w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
              <span className="text-white font-bold">2</span>
            </div>
            <p className="text-gray-300">Choose the appropriate size and style from the available options</p>
          </div>
          <div className="flex items-start">
            <div className="bg-blue-600 w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
              <span className="text-white font-bold">3</span>
            </div>
            <p className="text-gray-300">Click the 'Generate' button and wait for the generation to complete</p>
          </div>
          <div className="flex items-start">
            <div className="bg-blue-600 w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
              <span className="text-white font-bold">4</span>
            </div>
            <p className="text-gray-300">Download, share, or save the image in the gallery</p>
          </div>
        </div>
      </section>

      {/* Tips Section */}
      <section className="bg-gray-800 p-6 rounded-lg mb-8">
        <h2 className="text-2xl font-semibold mb-4">Tips for Best Results</h2>
        <ul className="list-disc list-inside text-gray-300 space-y-2">
          {tips.map((tip, index) => (
            <li key={index}>{tip}</li>
          ))}
        </ul>
      </section>

      {/* FAQs Section */}
      <section className="bg-gray-800 p-6 rounded-lg">
        <h2 className="text-2xl font-semibold mb-4">Frequently Asked Questions</h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-700 pb-4">
              <button
                className="w-full text-left flex justify-between items-center"
                onClick={() => setOpenSection(openSection === index ? null : index)}
              >
                <span className="font-semibold">{faq.question}</span>
                <span className="text-blue-500">
                  {openSection === index ? '−' : '+'}
                </span>
              </button>
              {openSection === index && (
                <p className="mt-2 text-gray-300">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Contact Section */}
      <section className="bg-gray-800 p-6 rounded-lg mt-8">
        <h2 className="text-2xl font-semibold mb-4">Need Additional Help?</h2>
        <p className="text-gray-300 mb-4">
          If you have any other questions, feel free to contact us:
        </p>
        <a
          href="mailto:support@aigenr.cc"
          className="text-blue-400 hover:text-blue-300"
        >
          support@aigenr.cc
        </a>
      </section>
    </div>
  );
}

export default Help; 